import imageServiceUrl from '../../image/instance'

const deleteProductImage = (productId) => {
	return imageServiceUrl.delete(`/images/products/${productId}`)
}

export default deleteProductImage
